import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

const LOCAL_STORAGE_KEY = 'selectedLanguage'

export const useLanguageSelector = () => {
  const { i18n } = useTranslation()
  const initialLanguage =
    localStorage.getItem(LOCAL_STORAGE_KEY) || i18n.language || 'pt-BR'
  const [tempLanguage, setTempLanguage] = useState<string>(initialLanguage)

  const languages: { label: string; value: string }[] = useMemo(
    () => [
      { label: 'Português (Brasil)', value: 'pt-BR' },
      { label: 'English (United States)', value: 'en-US' },
      { label: 'Español (España)', value: 'es-ES' },
    ],
    [],
  )

  const handleTempChange = (value: string) => {
    setTempLanguage(value)
  }

  const saveLanguage = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, tempLanguage)
    i18n.changeLanguage(tempLanguage)
  }

  const currentLanguage = useMemo(
    () => languages.find(lang => lang.value === tempLanguage),
    [tempLanguage, languages],
  )

  return {
    selectedLanguage: initialLanguage,
    tempLanguage,
    currentLanguage,
    formattedLanguages: languages,
    handleTempChange,
    saveLanguage,
  }
}
